import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { 
  HiOutlineHome, 
  HiOutlineClipboardList, 
  HiOutlineUserGroup, 
  HiOutlineCube, 
  HiOutlineLogout, 
  HiOutlineDocumentText, 
  HiOutlineShoppingCart, 
  HiOutlineCog,
  HiOutlineCurrencyDollar,
  HiOutlineBookOpen,
  HiOutlineClock,
  HiOutlineUpload,
  HiOutlineTruck,
  HiOutlineGlobe,
  HiOutlineLink
} from "react-icons/hi";
import { useUser } from "./UserContext";

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useUser();
  return (
    <aside className="fixed top-0 left-0 h-full w-64 bg-white border-r border-blue-100 shadow-lg z-50 flex flex-col">
      <div className="h-16 flex items-center justify-center border-b border-blue-100 flex-shrink-0">
        <span className="text-2xl font-bold text-blue-900">Admin Paneli</span>
      </div>
      <nav className="flex-1 flex flex-col gap-2 p-4 overflow-y-auto scrollbar-thin scrollbar-thumb-blue-200 scrollbar-track-transparent hover:scrollbar-thumb-blue-300">
        <Link to="/dash" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineHome className="w-5 h-5" /> Dashboard
        </Link>
        <Link to="/admin/guest-teklifler" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineClipboardList className="w-5 h-5" /> Misafir Teklifler
        </Link>
        <Link to="/admin/guest-firmalar" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineUserGroup className="w-5 h-5" /> Misafir Firmalar
        </Link>
        <Link to="/urunler" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineCube className="w-5 h-5" /> Ürün Listesi
        </Link>
        <Link to="/partnerler" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineUserGroup className="w-5 h-5" /> Partnerler
        </Link>
        <Link to="/proforma" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineDocumentText className="w-5 h-5" /> Proforma
        </Link>
        <Link to="/satislar" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineShoppingCart className="w-5 h-5" /> Satışlar
        </Link>
        <Link to="/uretim" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineCog className="w-5 h-5" /> Üretim
        </Link>
        <Link to="/lojistik" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineTruck className="w-5 h-5" /> Lojistik
        </Link>
        <Link to="/sut-fiyatlari" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineCurrencyDollar className="w-5 h-5" /> SUT Fiyatları
        </Link>
        <Link
          to="/sut-kutuphanesi"
          className={`flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
            location.pathname === '/sut-kutuphanesi'
              ? 'bg-blue-100 text-blue-700'
              : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
          }`}
        >
          <HiOutlineBookOpen className="mr-3 h-5 w-5" />
          SUT Kütüphanesi
        </Link>
        <Link to="/logs" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineDocumentText className="w-5 h-5" /> İşlem Kayıtları
        </Link>
        <Link to="/admin/temporary-links" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineClock className="w-5 h-5" /> Geçici Linkler
        </Link>
        <Link to="/admin/applications" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineClipboardList className="w-5 h-5" /> Başvurular
        </Link>
        <Link to="/admin/import-export" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineUpload className="w-5 h-5" /> Import/Export
        </Link>
        <Link to="/dash/dagitim-agi" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineGlobe className="w-5 h-5" /> Dağıtım Ağı
        </Link>
        <Link to="/dash/uts-yonetimi" className="flex items-center gap-3 px-3 py-2 rounded-lg text-blue-900 hover:bg-blue-50 font-semibold transition-colors duration-200">
          <HiOutlineLink className="w-5 h-5" /> UTS Yönetimi
        </Link>
        <Link to="/admin/mailing" className={`flex items-center gap-3 px-3 py-2 rounded-lg font-semibold transition-colors duration-200 ${location.pathname === '/admin/mailing' ? 'bg-blue-100 text-blue-700' : 'text-blue-900 hover:bg-blue-50'}`}>
          <HiOutlineClipboardList className="w-5 h-5" /> Mailing
        </Link>
        <Link to="/admin/help" className={`flex items-center gap-3 px-3 py-2 rounded-lg font-semibold transition-colors duration-200 ${location.pathname === '/admin/help' ? 'bg-blue-100 text-blue-700' : 'text-blue-900 hover:bg-blue-50'}`}>
          <HiOutlineBookOpen className="w-5 h-5" /> Yardım Yönetimi
        </Link>
      </nav>
      <div className="p-4 border-t border-blue-100 flex-shrink-0">
        <button className="flex items-center gap-2 px-3 py-2 rounded-lg text-red-700 hover:bg-red-50 font-semibold w-full transition-colors duration-200" onClick={() => { logout(); navigate('/login'); }}>
          <HiOutlineLogout className="w-5 h-5" /> Çıkış Yap
        </button>
      </div>
    </aside>
  );
}

export default AdminSidebar; 